import React, { useEffect, useState } from "react";
import MainComponentWrapper from "../Common/MainComponentWrapper";
import EarningDetailsCardSection from "./EarningDetailsCardSection";
import EarningTicketList from "./EarningTicketList";
import EarningDetialsOrderList from "./EarningDetailsOrderList";
import EarningDetailsPromotersList from "./EarningDetailsPromotersList";
import Filter from "./Filter";

const EarningDetails = ({
  isError,
  isLoading,
  details,
  getDetails,
  setDetails,
  setDataType,
  dataType,
  getOrderDetails,
  orderDetails,
  promoterDetails,
  handleTimeSpan,
  timeSpanInput,
}) => {
  return (
    <MainComponentWrapper Loading={isLoading} errorInfo={isError}>
      <div className="event-earning-detail-body">
        <Filter
          setDetails={setDetails}
          getDetails={getDetails}
          handleTimeSpan={handleTimeSpan}
          timeSpanInput={timeSpanInput}
          dataType={dataType}
          setDataType={setDataType}
        />

        <EarningDetailsCardSection
          isError={isError}
          isLoading={isLoading}
          details={details}
          dataType={dataType}
          orderDetails={orderDetails}
          promoterDetails={promoterDetails}
        />

        {dataType === "ticket" ? (
          <EarningTicketList
            isError={isError}
            isLoading={isLoading}
            details={details}
          />
        ) : dataType === "order" ? (
          <EarningDetialsOrderList
            isError={isError}
            isLoading={isLoading}
            eventDetails={orderDetails?.eventSettings}
            details={orderDetails?.orderListing}
            getDetails={getOrderDetails}
          />
        ) : (
          <EarningDetailsPromotersList
            isError={isError}
            isLoading={isLoading}
            details={promoterDetails}
          />
        )}
      </div>
    </MainComponentWrapper>
  );
};

export default EarningDetails;
